import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconConstructionHelmet: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="construction-helmet, work, wip"><path d="M9.75 15.25V3.75H14.25V15.25" stroke="currentColor" strokeWidth="1.5"/><rect x="2.75" y="14.75" width="18.5" height="4.5" stroke="currentColor" strokeWidth="1.5"/><path d="M3.5 14.7499V12.7499C3.5 8.92557 6.02566 5.69111 9.5 4.62354M20.5 14.7499V12.7499C20.5 8.92557 17.9743 5.69111 14.5 4.62354" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconConstructionHelmet;
